export const isDevelopment = () => process.env.NODE_ENV === 'development';
export const isProduction = () => process.env.NODE_ENV === 'production';
export const replaceEndSlash = (url, type = true) => {
  const bool = /\/$/.test(url)
  if (!url) return url
  if (type && !bool) return [url, '/'].join('')
  if (!type && bool) return url.split('').slice(0, -1).join('')
  if ((type && bool) || (!type && !bool)) return url
}

export const replaceStartSlash = (url, type = true) => {
  const bool = /^\//.test(url)
  if (!url) return url
  if (type && !bool) return ['/', url].join('')
  if (!type && bool) return url.split('').reverse().slice(0, -1).reverse().join('')
  if ((type && bool) || (!type && !bool)) return url
}